module.exports = __webpack_public_path__ + "img/icon-lock-black.9a61802d.svg";